// OpenAI APIクライアント

export interface ChatRequest {
  system: string;
  message: string;
}

export interface ChatResponse {
  reply: string;
}

export interface ChatError {
  error: string;
}

/**
 * Vercel FunctionsのAPI Routeを使用してOpenAIとチャットする
 */
export class OpenAIClient {
  private apiUrl: string;

  constructor(apiUrl: string = '/api/chat') {
    this.apiUrl = apiUrl;
  }

  /**
   * システムプロンプトとユーザーメッセージを送信してAIの応答を取得
   */
  async chat(system: string, message: string): Promise<string> {
    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          system,
          message,
        } as ChatRequest),
      });

      if (!response.ok) {
        const errorData: ChatError = await response.json();
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`
        );
      }

      const data: ChatResponse = await response.json();
      return data.reply;
    } catch (error) {
      console.error('OpenAI API error:', error);
      throw error;
    }
  }
}

// デフォルトのクライアントインスタンス
export const openAIClient = new OpenAIClient();

// 便利な関数
export const chatWithAI = (system: string, message: string) =>
  openAIClient.chat(system, message);
